import { render, staticRenderFns } from "./depthTable.vue?vue&type=template&id=c86805f6&scoped=true&"
import script from "./depthTable.vue?vue&type=script&lang=js&"
export * from "./depthTable.vue?vue&type=script&lang=js&"
import style0 from "./depthTable.vue?vue&type=style&index=0&id=c86805f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86805f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c86805f6')) {
      api.createRecord('c86805f6', component.options)
    } else {
      api.reload('c86805f6', component.options)
    }
    module.hot.accept("./depthTable.vue?vue&type=template&id=c86805f6&scoped=true&", function () {
      api.rerender('c86805f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/depth/depthTable.vue"
export default component.exports